import populationActivitiesLang from "@/langs/population/populationActivities";

const populationLang = {
  en: {
    population: "Population",
    populationServed: "Population served",
    externalPersonForIncident: "External person for incident",
    institution: "Institution",
    listPopulation: "Population list",
    addPopulation: "Add person",
    createPerson: "Create person",
    names: "Names",
    lastNames: "Last names",
    firstName1: "First name",
    firstName2: "Second name",
    firstName3: "Third name",
    lastName1: "First last name",
    lastName2: "Second last name",
    lastNameMarried: "Married last name",
    identificationType: "Identification type",
    documentNumber: "Document number",
    religion: "Religion",
    idPerson: "ID person",
    alias: "Nickname",
    age: "Age",
    civilStatus: "Civil status",
    sex: "Sex",
    sexualOrientation: "Sexual orientation",
    nationality: "Nationality",
    ethnicGroup: "Ethnic group",
    linguisticCommunity: "Linguistic community",
    ageGroup: "Age group",
    academicDegree: "Academic degree",
    knowsRead: "Knows read",
    knowsWrite: "Knows write",
    personWithDisability: "Person with Disability?",
    sureDeleteAssociation: "Sure delete association?",
    explainYourAnswer: "Explain your answer",
    areYouPregnant: "Are you pregnant?",
    guatemalan: "Guatemalan",
    foreign: "Foreign",
    country: "Country",
    state: "State",
    town: "Town",
    community: "Community",
    weight: "Weight (lbs)",
    height: "Height (mts)",
    phoneHouse: "Phone house",
    phoneEmergency: "Phone house",
    bloodType: "Blood type",
    personalInformation: "Personal information",
    entranceToPrograms: "Entrance to programs",
    legalInformation: "Legal Information",
    careReceived: "Care received",
    linkedPeople: "Linked people",
    perpetrator: "Perpetrator",
    numberOfExternalFiles: "Number of external files",
    dateAdmission: "Date of admission",
    reasonAdmission: "Reason of admission",
    referrer: "Referrer",
    referring: "Referring",
    court: "Court",
    thematic: "Thematic",
    thematicDivision: "Thematic division",
    logicFrame: "Logic frame",
    task: "Task",
    rescuedPerson: "Rescued person?",
    report: "Report",
    right: "Right",
    rightDivision: "Right division",
    assignPermission: "Assign permission",
    assignRight: "Assign right",
    assignCareReceived: "Assign care received",
    addCareReceived: "Add care received",
    activityDate: "Activity date",
    person_insert_succesful: "The person has saved correctly",
    person_updated_successful: "The person has updated correctly",
    addProgram: "Add program",
    lastResidence: "Last residence",
    enterLinkedPerson: "Enter linked person",
    linkedReport: "Linked people report (PDF)",
    onlyPdfAllowed: "Only PDF files are allowed.",
    dateDeparture: "Date departure",
    admin: "Admin",
    canRead: "Can read",
    canWrite: "Can write",
    addUser: "Add user",
    letOut: "Let out",
    linkPerson: "Link person",
    bond: "Bond",
    addOffender: "Add offender",
    complaint: "Complaint",
    caseNumber: "Case number",
    numberOfExternalFilesSimbol: "# record",
    noteDeparture: "Departure note",
    seePermissions: "See permissions",
    requestPermission: "Request permission",
    syncGroupPermissions: "Update work group permissions",
    groupPermissionsSynced: "Permissions updated. {0} new assignment(s) added.",
    syncAllPermissions: "Update permissions (all)",
    allPermissionsSynced: "Permissions updated: {0} new assignment(s) across {1} person(s).",
    removeBond: "Remove bond",
    person_activity_insert_succesful:
      "The person's activity has been added successfully",
    person_activity_updated_successful:
      "The person's activity has been updated successfully",
    person_victimizer_insert_succesful:
      "The offender has been added successfully",
    person_victimizer_deleted_successful:
      "The offender has been deleted successfully",
    person_activity_deleted_successful:
      "The person's activity has been deleted successfully",
    person_asignation_insert_succesful: "The user has been added successfully",
    person_retrieved_successful: "The access request was sent successfully",
    person_asignation_updated_successful:
      "The access request was sent successfully",
    sureDeleteActivity: "Are you sure to delete the activity?",
    sureDeleteBond: "Are you sure to delete the bond?",
    sureDeletePerpetrator: "Are you sure to delete the perpetrator?",
    person_family_bond_deleted_successful:
      "The bond has been deleted successfully",
    editorHint: "Use the buttons to format the text. You can insert headings and black text.",
    writeHere: "Write here...",
    protectionMeasureType: "Protection measure type",
    orderIssueDate: "Order issue date",
    measureExpiryDate: "Measure expiry date",
    legalStatus: "Legal status",
    assignedLawyer: "Assigned lawyer",
    exitCondition: "Exit condition",
    reintegrationPlan: "Reintegration plan",
    followUpRequired: "Follow up required",
    followUpFrequency: "Follow up frequency",
    residenceProgram: "Residence/program",
    admissionReason: "Admission reason",
    admissionReasonDivision: "Admission reason division",
    template: "Template",
    templateFields: "Template Fields",
    errorGettingTemplates: "Error getting templates",
    errorParsingTemplate: "Error parsing template",
    documentation: "Documentation",
    addDocument: "Add Document",
    editDocument: "Edit Document",
    documentName: "Document Name",
    documentType: "Document Type",
    documentDate: "Document Date",
    fileSize: "File Size",
    confidential: "Confidential",
    selectFile: "Select File",
    fileTypesAllowed: "Allowed file types",
    file: "File",
    actions: "Actions",
    description: "Description",
    view: "View",
    download: "Download",
    viewExit: "View exit",
    exitInformation: "Exit information",
    expedientNumber: "Expedient number",
    printExitReport: "Print exit report",
    ...populationActivitiesLang.en,
  },
  es: {
    population: "Población",
    populationServed: "Población atendida",
    listPopulation: "Listado de población",
    externalPersonForIncident: "Persona externa para incidencia",
    institution: "Institución",
    addPopulation: "Agregar persona",
    createPerson: "Crear persona",
    names: "Nombres",
    lastNames: "Apellidos",
    firstName1: "Primer nombre",
    firstName2: "Segundo nombre",
    firstName3: "Tercer nombre",
    lastName1: "Primer apellido",
    lastName2: "Segundo apellido",
    lastNameMarried: "Apellido de casada",
    identificationType: "Tipo de identificación",
    documentNumber: "Número de documento",
    religion: "Religión",
    idPerson: "ID persona",
    alias: "Alias",
    age: "Edad",
    civilStatus: "Estado civil",
    sex: "Sexo",
    sexualOrientation: "Orientación sexual",
    nationality: "Nacionalidad",
    ethnicGroup: "Grupo étnico",
    linguisticCommunity: "Comunidad lingüística",
    ageGroup: "Grupo etario",
    academicDegree: "Grado académico",
    knowsRead: "Sabe leer",
    knowsWrite: "Sabe escribir",
    sureDeleteAssociation: "¿Está seguro de eliminar la asociación?",
    personWithDisability: "¿Persona con discapacidad?",
    explainYourAnswer: "Especifique su respuesta",
    areYouPregnant: "¿Se encuentra en estado de gestación?",
    guatemalan: "Guatemalteco",
    foreign: "Extranjero",
    country: "País",
    state: "Departamento",
    town: "Municipio",
    community: "Comunidad",
    weight: "Peso (lbs)",
    height: "Altura (mts)",
    phoneHouse: "Teléfono de casa",
    phoneEmergency: "Teléfono de emergencia",
    bloodType: "Tipo de sangre",
    personalInformation: "Información personal",
    entranceToPrograms: "Ingreso a programas",
    legalInformation: "Información Legal",
    careReceived: "Atenciones recibidas",
    linkedPeople: "Personas vinculadas",
    perpetrator: "Victimario",
    numberOfExternalFiles: "Número de expedientes externo",
    dateAdmission: "Fecha de ingreso",
    reasonAdmission: "Motivo de ingreso",
    referrer: "Referente",
    referring: "Referente",
    court: "Juzgado",
    thematic: "Temática",
    thematicDivision: "División temática",
    logicFrame: "Marco lógico",
    task: "Tarea",
    rescuedPerson: "¿Persona rescatada?",
    report: "Informe",
    right: "Derecho",
    rightDivision: "División derecho",
    assignPermission: "Asignar permiso",
    assignRight: "Asignar derecho",
    assignCareReceived: "Asignar atención recibida",
    addCareReceived: "Agregar atención recibida",
    activityDate: "Fecha de actividad",
    person_insert_succesful: "La persona se ha guardado correctamente",
    person_updated_successful: "La persona se ha actualizado correctamente",
    addProgram: "Agregar programa",
    lastResidence: "Última residencia",
    enterLinkedPerson: "Agregar persona vinculada",
    linkedReport: "Informe de vinculadas (PDF)",
    onlyPdfAllowed: "Solo se permiten archivos PDF.",
    dateDeparture: "Fecha de salida",
    admin: "Administrador",
    canRead: "Puede leer",
    canWrite: "Puede escribir",
    addUser: "Agregar usuario",
    letOut: "Dar salida",
    linkPerson: "Vincular persona",
    bond: "Vínculo",
    addOffender: "Agregar victimario",
    complaint: "Denuncia",
    caseNumber: "Número de causa",
    numberOfExternalFilesSimbol: "# expediente",
    noteDeparture: "Nota de salida",
    seePermissions: "Ver permisos",
    requestPermission: "Solicitar permiso",
    syncGroupPermissions: "Actualizar permisos del grupo",
    groupPermissionsSynced: "Permisos actualizados. Se agregaron {0} asignación(es) nueva(s).",
    syncAllPermissions: "Actualizar permisos (todos)",
    allPermissionsSynced: "Permisos actualizados: {0} asignación(es) nueva(s) en {1} persona(s).",
    removeBond: "Quitar vínculo",
    person_activity_insert_succesful:
      "La actividad de la persona se ha agregado correctamente",
    person_activity_updated_successful:
      "La actividad de la persona se ha actualizado correctamente",
    person_victimizer_insert_succesful:
      "El victimario se ha agregado correctamente",
    person_victimizer_deleted_successful:
      "El victimario se ha eliminado correctamente",
    person_activity_deleted_successful:
      "La actividad se ha eliminado correctamente",
    person_asignation_insert_succesful:
      "El usuario se ha agregado correctamente",
    person_retrieved_successful:
      "La solicitud de acceso se envió correctamente",
    sureDeleteActivity: "¿Está seguro de borrar la actividad?",
    sureDeleteBond: "¿Está seguro de borrar el vínculo?",
    sureDeletePerpetrator: "¿Está seguro de borrar el victimario?",
    person_family_bond_deleted_successful:
      "Se ha eliminado el vínculo de la persona",
    editorHint: "Utilice los botones para formatear el texto. Puede insertar títulos y texto en negrita.",
    writeHere: "Escriba aquí...",
    protectionMeasureType: "Tipo de medida de protección",
    orderIssueDate: "Fecha de emisión de orden",
    measureExpiryDate: "Fecha de vencimiento de medida",
    legalStatus: "Estatus legal",
    assignedLawyer: "Abogado asignado",
    exitCondition: "Condición de egreso",
    reintegrationPlan: "Plan de reintegración",
    followUpRequired: "Requiere seguimiento",
    followUpFrequency: "Frecuencia de seguimiento",
    residenceProgram: "Residencia/programa",
    admissionReason: "Motivo de ingreso",
    admissionReasonDivision: "División de motivo de ingreso",
    template: "Plantilla",
    templateFields: "Campos de Plantilla",
    errorGettingTemplates: "Error obteniendo plantillas",
    errorParsingTemplate: "Error procesando plantilla",
    documentation: "Documentación",
    addDocument: "Agregar Documento",
    editDocument: "Editar Documento",
    documentName: "Nombre del Documento",
    documentType: "Tipo de Documento",
    documentDate: "Fecha del Documento",
    fileSize: "Tamaño del Archivo",
    confidential: "Confidencial",
    selectFile: "Seleccionar Archivo",
    fileTypesAllowed: "Tipos de archivo permitidos",
    file: "Archivo",
    actions: "Acciones",
    description: "Descripción",
    view: "Ver",
    download: "Descargar",
    viewExit: "Ver salida",
    exitInformation: "Información de salida",
    expedientNumber: "Número de expediente",
    printExitReport: "Imprimir reporte de salida",
    ...populationActivitiesLang.es,
  },
};
export default populationLang;
